module.exports = __webpack_public_path__ + "static/media/Twodash_orange.6041e1b0.svg";